<!--  -->
<template>
  <div>
    <el-form label-position="right" label-width="110px" :model="form">
      <el-form-item label="企业">
        <el-tag v-if="form.corp_id!=''" style="margin-right:10px">{{ name }} ({{ form.corp_id }}) </el-tag>
        <el-button type="primary" size="mini" @click="choose">选择企业</el-button>
      </el-form-item>
      <el-form-item label="企业员工">
        <el-tag v-for="items,index in form.userids" :key="index" style="margin-right:10px" closable @close="handleClose(index)">{{ items.name }} </el-tag>
        <el-button :disabled="form.corp_id===''" type="primary" size="mini" @click="chorwe">选择企业员工</el-button>
      </el-form-item>
      <el-form-item label="类型">
        <el-radio-group v-model="form.type">
          <el-radio-button :label="1">普通账号</el-radio-button>
          <el-radio-button :label="2">互通账号</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="sumbitr">确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择企业"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :destroy-on-close="true"
      width="60%"
    >
      <enterprise @callback="callback" />
    </el-dialog>
    <el-dialog
      title="绑定员工"
      :visible.sync="dialogVisibler"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="50%"
    >
      <bandstaff ref="bandstaffview" @bandarr="bandarr" />
    </el-dialog>
  </div>
</template>

<script>
import enterprise from '../../behavioralsource/components/enterprise.vue'
import bandstaff from '../../behavioralsource/components/bandstaff.vue'
import { activateUsers } from '@/api/officialaccount.js'
export default {
  components: { enterprise, bandstaff },
  data() {
    return {
      dialogVisible: false,
      dialogVisibler: false,
      name: '',
      form: {
        corp_id: '',
        userids: [],
        type: 1
      },
      useridsall: []
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    choose() {
      this.dialogVisible = true
    },
    callback(item) {
      this.dialogVisible = false
      this.name = item.corp_name
      this.form.corp_id = item.corp_id
      this.form.userids = []
    },
    chorwe() {
      this.dialogVisibler = true
      this.$nextTick(() => {
        this.$refs.bandstaffview.sendr(this.form.corp_id, this.form.userids)
      })
    },
    async bandarr(arr, sp_strategy_no, arrname) {
      this.dialogVisibler = false
      this.form.userids = arr
      console.log(arr)
    },
    handleClose(index) {
      this.form.userids.splice(index, 1)
    },
    async sumbitr() {
      if (this.form.corp_id === '') {
        this.$message.error('请选择企业')
        return
      }
      if (this.form.userids.length === 0) {
        this.$message.error('请选择企业员工')
        return
      }
      this.useridsall = []
      this.useridsall = this.form.userids.map((item) => {
        return item.user_id
      })
      const data = await activateUsers({
        userids: this.useridsall,
        corp_id: this.form.corp_id,
        type: this.form.type
      })
      console.log(data)
      this.$emit('updata')
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
